export default __webpack_public_path__ + "static/media/02.7d173618.svg";